import { useState, useCallback } from 'react';
import { ToastMessage } from '../components/common/Toast';

let toastIdCounter = 0;

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const showToast = useCallback(
    (
      message: string,
      type: ToastMessage['type'] = 'info',
      duration?: number,
      action?: { label: string; onClick: () => void }
    ) => {
      const id = `toast-${++toastIdCounter}`;
      const newToast: ToastMessage = {
        id,
        message,
        type,
        duration,
        action,
      };

      setToasts((prev) => [...prev, newToast]);
      return id;
    },
    []
  );

  const closeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const success = useCallback(
    (message: string, duration?: number, action?: { label: string; onClick: () => void }) => {
      return showToast(message, 'success', duration, action);
    },
    [showToast]
  );

  const error = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'error', duration);
    },
    [showToast]
  );

  const warning = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'warning', duration);
    },
    [showToast]
  );

  const info = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'info', duration);
    },
    [showToast]
  );

  return {
    toasts,
    showToast,
    closeToast,
    success,
    error,
    warning,
    info,
  };
};
